import './detailed-view.component.ajscss';

import { DomainResult, IHypervisionService } from '@hypervision/hypervision.service';
import { Domain } from '@hypervision/models/domain';
import { Indicator } from '@hypervision/models/indicator';
import { IComponentController, IComponentOptions, IFilterService } from 'angular';

import { DisplayDeprecatedComponent } from '@contact/upgrade';

import templateUrl from './detailed-view.component.ajs.html';

class DetailedViewCtrl extends DisplayDeprecatedComponent implements IComponentController {
  public filterState: boolean;
  public domains: Domain[];
  private indicators: Indicator[] = [];
  private maxChecked: number;
  private checked: number;

  constructor(private readonly $filter: IFilterService, private readonly hypervision: IHypervisionService) {
    super();
  }

  override onWatchSize(size: string) {
    if (size !== undefined) {
      switch (size) {
        case 'xsmall':
          this.maxChecked = 2;
          break;
        case 'small':
          this.maxChecked = 4;
          break;
        case 'medium':
          this.maxChecked = 6;
          break;
        case 'large':
          this.maxChecked = 10;
          break;
        default:
          this.maxChecked = 5;
          break;
      }
    }
  }

  $onInit() {
    this.filterState = false;
    this.domains = [];
    this.indicators = this.hypervision.getIndicators(false) ?? [];

    this.maxChecked = 2;
    this.checked = 0;

    this.hypervision.onUpdated(() => this.getDomainsMetrics());
    this.getDomainsMetrics();
    this.selectDefaultIndicator();
  }

  enableMetric(item) {
    if (item.displayed) this.checked++;
    else this.checked--;
  }

  private getDomainsMetrics() {
    this.hypervision.getDomainsMetrics().then((response: DomainResult) => {
      this.domains = this.$filter('orderBy')(response.list, 'fullName', false);
    });
  }
  private selectDefaultIndicator() {
    this.checked = 0;
    this.indicators.forEach(indicator => {
      // keep selected selected
      if (indicator.displayed) {
        if (this.checked >= this.maxChecked) {
          indicator.displayed = false;
        } else {
          this.checked++;
        }
      }
    });
    // select other not selected for fill space
    if (this.checked < this.maxChecked) {
      this.indicators.forEach(indicator => {
        if (!indicator.displayed) {
          if (this.checked < this.maxChecked) {
            indicator.displayed = true;
            this.checked++;
          } else {
            indicator.displayed = false;
          }
        }
      });
    }
  }
}

export class DetailedView implements IComponentOptions {
  templateUrl = templateUrl;
  bindings = {};
  controller = ['$filter', 'hypervision', DetailedViewCtrl];
}

export default 'detailedView';
